export const styles = (theme) => ({
  trackview: {
    width: "calc(100% - 170px)",
    height: "calc(100% - 235px)",
    top: "72px",
    overflow: "auto",
  },

  mainContainer: {
    clear: "left",
    position: "relative",
    left: "0",
    width: "100%",
  },

  mainwrapExpanded: {
    position: "relative",
    background: "#000 ",
    width: "calc(100% - 68px) !important",
    height: "calc(100vh - 67px)",
    float: "left",
  },

  mainwrapCollpsed: {
    position: "relative",
    background: "#000 ",
    width: "calc(100% - 100px) !important",
    height: "calc(100vh - 67px)",
    float: "left",
  },

  

  mainwrap: {
    position: "relative",
    background: "#000 ",
    width: "calc(100% - 183px)",
    height: "calc(100vh - 65px)",
    float: "left",

    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 160px)",
    },
    [theme.breakpoints.up("md")]: {
      width: "calc(100% - 182px)",
    },
    [theme.breakpoints.up("lg")]: {
      width: "calc(100% - 182px)",
    },
  },

  naviLinksCollpsed: {
    width: "60px",
    background: "#303030 ",
    float: "left",
    height: "calc(100vh - 84px)",
    overflow: "auto",
    "& svg":{
      margin:"0",
    },
    "& p":{
      display:"none",
    },
    "& .MuiIconButton-label":{
      display:"none",
    },
    "& .MuiTypography-root":{
      display:"none",
    },
    "& .customLinkText":{
      display:"none",
    },
    "& .externalLinks":{
      textAlign: "center",
      padding:"6px 12px 10px 7px",     
    },
    "& .externalLinks:hover svg":{
      color:"#26B70B",     
    },
    "& .externalLinks:hover path":{
      color:"#26B70B",
      stroke: "#26B70B",
    },
    "& .MuiListItem-root":{
      padding:"6px 12px 10px 7px",
    },
    "& .MuiListItemIcon-root":{
      minWidth: "24px",
      margin: "0 auto",
    },
    "& .MuiAccordionDetails-root":{
      background: "#000000",
    },
    "& .MuiAccordionSummary-expandIcon":{
      display:"none",
    }
  },

  naviLinksHide: {
    width: "0px"
  },

  naviLinks: {
    width: "177px",
    background: "#303030 ",
    float: "left",
    height: "calc(100vh - 79px)",
    overflow: "auto",

    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      width: "160px",
    },
    [theme.breakpoints.up("md")]: {
      width: "177px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "177px",
    },
  },
  paper: {
    background: "none",
    boxShadow: "none",
  },
  mainwrapRightCollpsed: {
    width: "calc(100% - 177px) !important",
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
    },
    [theme.breakpoints.up("md")]: {
    },
    [theme.breakpoints.up("lg")]: {
      "& .advancedSearchforLaptop > div": {
        // display: "flex !important",
      },
      "& .advancedSearchforLaptop": {
        "& .searchButtonsSet": {
          marginLeft: "0px !important",
          
        }
      },
      "& .albumSearchforLaptop > div":{
        // display: "flex !important",
      },
      "& .albumSearchforLaptop": {
        "& .searchButtonsSet": {
          marginLeft: "0px !important",
       
        }
      },
    },     
  },
  mainwrapRightHide: {
    width: "calc(100% - 5px) !important",
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
    },
    [theme.breakpoints.up("md")]: {
    },
    [theme.breakpoints.up("lg")]: {
      "& .advancedSearchforLaptop > div": {
        // display: "flex !important",
      },
      "& .advancedSearchforLaptop": {
        "& .searchButtonsSet": {
          marginLeft: "0px !important",
          
        }
      },
      "& .albumSearchforLaptop > div":{
        // display: "flex !important",
      },
      "& .albumSearchforLaptop": {
        "& .searchButtonsSet": {
          marginLeft: "0px !important",
       
        }
      },
    },     
  },
  mainwrapCollpsed: {
    width: "calc(100% - 60px) !important",
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
    },
    [theme.breakpoints.up("md")]: {
    },
    [theme.breakpoints.up("lg")]: {
      "& .advancedSearchforLaptop > div": {
        // display: "flex !important",
      },
      "& .advancedSearchforLaptop": {
        "& .searchButtonsSet": {
          marginLeft: "0px !important",
          marginTop: "0px!important",
        }
      },
      "& .albumSearchforLaptop > div":{
        // display: "flex !important",
      },
      "& .albumSearchforLaptop": {
        "& .searchButtonsSet": {
          marginLeft: "0px !important",
          marginTop: "0px!important",
        }
      },
    },     
  },
  hideText:{
    opacity:" 0",
    position: "absolute",
    left: "-1000px",
  }
});
